// namespace Pacem {
/** Grants undo/redo functionalities for given state. */
export class HistoryService {
    constructor(state, maxlength) {
        this.#current = state;
        this.#maxlength = maxlength;
    }
    // it's a queue
    #backwards = [];
    // it's a stack
    #forwards = [];
    // max number of items (queue + stack)
    #maxlength;
    #current;
    /**
     * Gets the current state.
     */
    get current() {
        return this.#current;
    }
    get canUndo() {
        return this.#backwards.length > 0;
    }
    get canRedo() {
        return this.#forwards.length > 0;
    }
    /** Sets the maximum number of stored states, queue + stack.
     */
    set maxlength(v) {
        this.#maxlength = v;
    }
    undo() {
        if (this.canUndo) {
            const back = this.#backwards, fore = this.#forwards, current = this.#current;
            fore.unshift(current);
            this.#current = back.pop();
        }
    }
    redo() {
        if (this.canRedo) {
            const back = this.#backwards, fore = this.#forwards, current = this.#current;
            back.push(current);
            this.#current = fore.shift();
        }
    }
    push(state) {
        this.#forwards.splice(0);
        this.#backwards.push(this.#current);
        this.#current = state;
        const max = this.#maxlength, queue = this.#backwards;
        if (max > 0 && queue.length > max) {
            queue.splice(0, queue.length - max);
        }
    }
    reset() {
        this.#forwards.splice(0);
        this.#backwards.splice(0);
    }
}
// }
